import { Routes, Route } from 'react-router-dom';
import { RequireAuth } from './lib/auth';
import { AppShell } from './components/layout/AppShell';
import { AuditExperienceShell } from './components/audit/AuditExperienceShell';
import { MarketingLayout } from './components/marketing/MarketingLayout';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { AuditForkLandingPage } from './pages/AuditForkLandingPage';
import { AuditDashboardPage } from './pages/AuditDashboardPage';
import { AuditConversePage } from './pages/AuditConversePage';
import { AuditInvitationsPage } from './pages/AuditInvitationsPage';
import { RespondShell } from './pages/RespondShell';
import { MaterializePage } from './pages/MaterializePage';
import { ProposalReviewPage } from './components/materialize/ProposalReviewPage';
import { CoursePage } from './pages/CoursePage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { LandingPage } from './pages/marketing/LandingPage';
import { BlueprintSalesPage } from './pages/marketing/BlueprintSalesPage';
import { CheckoutPage } from './pages/marketing/CheckoutPage';
import { ThanksPage } from './pages/marketing/ThanksPage';
import { OtoPage } from './pages/marketing/OtoPage';
import { CourseOfferPage } from './pages/marketing/CourseOfferPage';
import { isDownsellEnabled } from './lib/downsell';

export function App() {
  return (
    <Routes>
      {/* Marketing surfaces — public, wrapped in MarketingLayout.
          "/" stays the early-access page (owner direction 2026-06-11); the
          live funnel entry is /blueprint → /checkout → /oto → /thanks. */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/blueprint" element={<BlueprintSalesPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/thanks" element={<ThanksPage />} />
        <Route path="/oto" element={<OtoPage />} />
        {/* Downsell stub — registered only when the build-time flag is on;
            copy and price are owner-pending (funnel v2 item 6). */}
        {isDownsellEnabled() ? <Route path="/course-offer" element={<CourseOfferPage />} /> : null}
      </Route>

      {/* Auth */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Public respond page — token exchanges for an httpOnly cookie inside
          RespondShell, which then drives a fully chat-based stakeholder
          experience. */}
      <Route path="respond/:token" element={<RespondShell />} />

      {/* Audit experience — auth-gated under AppShell */}
      <Route path="/" element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route path="start" element={<AuditForkLandingPage />} />
        <Route path="audits" element={<AuditDashboardPage />} />
        {/* Task 3: DIY Implementation Course — entitlement-gated inside the page. */}
        <Route path="course" element={<CoursePage />} />
        <Route path="audits/:id" element={<AuditExperienceShell />}>
          <Route index element={<AuditConversePage />} />
          <Route path="invitations" element={<AuditInvitationsPage />} />
        </Route>
        {/* Task 5 (#1738): lock-in lands here — review the proposal, then
            confirm starts materialization bound to the reviewed version. */}
        <Route path="audits/:id/review" element={<ProposalReviewPage />} />
        <Route path="audits/:id/materialize" element={<MaterializePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
